import styled from 'styled-components';

export const ComplexTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;
